var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e31c1c00-62ca-4f25-828b-48f6d0c841bb",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fea82caa-26fa-4870-b80c-f7c8431cef82",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,11.63a9.32,9.32,0,0,0-13.2,0l2.21,2.21A6.14,6.14,0,0,1,12,12a6.25,6.25,0,0,1,4.4,1.82ZM8.89,18.22A3.11,3.11,0,1,0,12,15.11,3.13,3.13,0,0,0,8.89,18.22ZM12,5.78a12.37,12.37,0,0,1,8.79,3.65L23,7.22a15.55,15.55,0,0,0-22,0L3.21,9.43A12.37,12.37,0,0,1,12,5.78Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.257634aac5e2b1e54d9c8c5e9344f9e9.svg";
export { ForwardRef as ReactComponent };